import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PERMISSION, PageProps, SECURABLE} from "core/metamodel/metaConstant";
import {PAGE} from "routes";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import securityService from "core/security/securityService";
import {lovValue} from "core/form/formUtils";
import {loc} from "core/common/config/locales";


const gridLocation = 'priceComponentList';

@observer
export default class PriceComponentList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.product;
  static title = loc.i18n`Prices`;
  static icon = 'dollar';
  static rootPage = true;
  static protectedPage = true;

  static fetchData(routerParams) {
    console.log("PriceComponentList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
    });
  }

  render() {
    let {params, query} = this.props;

    const curr: string = lovValue(securityService.currentTenant.defaultCurrency);

    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}
                           multiUpdateSecurable={SECURABLE.productGridUpdate}>
          <ZzFlatButtonRoute onGridToolbar routeName="priceComponentDetail" params={{id: 'new'}} query={{priceCurrency: curr}} label={loc.i18n`New Price`} permission={PERMISSION.New} securable={PAGE.priceComponentDetail}/>
        </GridCompConnected>
    );
  }

}



// WEBPACK FOOTER //
// ./src/product/page/priceComponentList.tsx